import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import { SAVE_CURRENT_CAMPAIGN } from "../store/drip-campaign-actions";
import { GET_MARKETING_EMAILS } from "@Broker/@Modules/marketing/store/marketing/marketing-getters";
import MaterialInput from "@Shared/components/inputs/material-input";
import CreateEmailModal from "@Broker/@Modules/marketing/components/campaigns/create-email-modal";
import MarketingAddressDisclaimerModal from "./modals/marketing-address-disclaimer-modal";
import MarketingEmailsSelect from "@Broker/@Modules/marketing/components/campaigns/marketing-emails-select";
import AddressSection from "@Shared/components/sections/new-sections/address-section";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DripCampaignEditAddress",
  components: {
    MaterialInput,
    AddressSection,
    CreateEmailModal,
    MarketingEmailsSelect,
    MarketingAddressDisclaimerModal
  },
  props: {
    currentCampaign: {
      type: Object,
      required: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    $v: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showEmailVerify: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("MarketingStore", [GET_MARKETING_EMAILS])), {}, {
    address() {
      return this.currentCampaign.address;
    },
    fromName: {
      get() {
        return this.currentCampaign.fromName;
      },
      set(val) {
        const data = {
          fromName: val
        };
        this.SAVE_CURRENT_CAMPAIGN(data);
      }
    },
    selectedEmail() {
      var _context;
      return _findInstanceProperty(_context = this.GET_MARKETING_EMAILS).call(_context, email => email.emailId === this.currentCampaign.emailId);
    },
    isSelectedEmailVerified() {
      var _this$selectedEmail;
      return (_this$selectedEmail = this.selectedEmail) == null ? void 0 : _this$selectedEmail.verified;
    },
    addressCustomExpressions() {
      return {
        "street-name": "currentCampaign.address.street-name",
        city: "currentCampaign.address.city",
        province: "currentCampaign.address.province",
        "postal-code": "currentCampaign.address.postal-code"
      };
    }
  }),
  watch: {
    isSelectedEmailVerified: {
      handler(val) {
        this.SAVE_CURRENT_CAMPAIGN({
          emailVerified: val
        });
      },
      immediate: true
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DripCampaignStore", [SAVE_CURRENT_CAMPAIGN])), {}, {
    handleAddressChange(val) {
      const data = {
        address: val
      };
      this.SAVE_CURRENT_CAMPAIGN(data);
    },
    handleEmailChange(val) {
      const data = {
        emailId: val.id
      };
      this.SAVE_CURRENT_CAMPAIGN(data);
    },
    handleCreateEmail() {
      this.showEmailVerify = false;
      this.openVerifyEmailModal();
    },
    handleVerifySelectedEmail() {
      this.showEmailVerify = true;
      this.openVerifyEmailModal();
    },
    openVerifyEmailModal() {
      this.$refs.createEmailModal.handleShow();
    },
    handleOpenDisclaimerModal() {
      this.$refs.disclaimerModal.showModal();
    }
  })
});